import { useNotifications as _useNotifications } from '@hwm/ui-lib';

export const useNotifications = () => {
  const notifications = _useNotifications({});

  return notifications;
};
